var _path, _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spy-search-icon",
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4756 3.05206C19.4852 1.85728 23.3823 -0.413082 30.8936 0.0647583C33.9223 -0.134374 40.8284 0.064846 44.2207 2.45441C45.4322 3.64918 47.8553 7.53241 47.8555 13.5062L46.5322 13.5179C63.3959 15.4349 62.999 16.7942 62.999 21.8704C62.9988 24.6107 58.9263 28.2258 48.333 30.2337H48.7637L47.5527 35.013C50.9447 35.491 55.6285 37.0045 57.5469 37.7015L37.5576 48.7532L39.6777 42.1819L0.908203 61.0003L2.72559 49.0521C3.6948 45.9456 10.6009 42.7791 13.9326 41.5843L11.5098 35.9095L15.75 35.013L14.2998 30.4378C4.2002 28.4363 0 24.4391 0 20.6751C0.000226678 16.7773 4.19311 14.9396 15.1357 13.5521C15.0952 11.6033 15.696 7.16389 18.4756 3.05206ZM17.1592 21.0003C16.6033 22.1009 17.4368 23.9939 20.7725 25.4026C24.1082 26.8114 26.9807 25.4023 28 24.5218L17.1592 21.0003ZM33 24.5218C34.1119 25.4023 37.2458 26.8114 40.8848 25.4026C44.5232 23.9941 45.4332 22.1009 44.8271 21.0003L33 24.5218Z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #spy-search-icon path { fill: url(#bg) }\n        .dark #spy-search-icon path { fill: url(#bg-dark) }\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 30.5) rotate(90) scale(30.5 31.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D8FFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-dark",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29 26) rotate(87.546) scale(35.0321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpySearch);
export default __webpack_public_path__ + "static/media/spy-search.602e437f19fcec2508595d1cb2850fba.svg";
export { ForwardRef as ReactComponent };